import { Country } from '@cash-web/protos/squareup/common/countries.pb'
import { FormBlockerElementAddressElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { AddressInput } from '@cash-web/shared-feature-form'

type AddressElementProps = FormBlockerElementAddressElement & { formSectionIndex: number }
export const AddressElement = ({ country_code, prefill_address, formSectionIndex }: AddressElementProps) => {
  return (
    <AddressInput
      countryCode={country_code ?? Country.US}
      fieldNames={{
        address_line_1: `${formSectionIndex}.address_result.address.address_line_1`,
        address_line_2: `${formSectionIndex}.address_result.address.address_line_2`,
        locality: `${formSectionIndex}.address_result.address.locality`,
        administrative_district_level_1: `${formSectionIndex}.address_result.address.administrative_district_level_1`,
        postal_code: `${formSectionIndex}.address_result.address.postal_code`,
      }}
      requiresCity={true}
      requiresPostalCode={true}
      requiresState={true}
      requiresStreetAddress={true}
      prefill={{
        street: prefill_address?.address_line_1,
        apartment: prefill_address?.address_line_2,
        city: prefill_address?.locality,
        state: prefill_address?.administrative_district_level_1,
        postalCode: prefill_address?.postal_code,
      }}
    />
  )
}
